"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _lodash = require("lodash");

var _gatsby = require("gatsby");

var _Layout = _interopRequireDefault(require("./Layout"));

var _BlogRoll = _interopRequireDefault(require("../columns/BlogRoll"));

var AllTagsPage = function AllTagsPage(_ref) {
  var _ref$data = _ref.data,
      _ref$data$pageDef = _ref$data.pageDef,
      fields = _ref$data$pageDef.fields,
      frontmatter = _ref$data$pageDef.frontmatter,
      tags = _ref$data.tagList.frontmatter,
      group = _ref$data.groupTags.group,
      posts = _ref$data.posts.edges,
      title = _ref$data.site.siteMetadata.title,
      padding = _ref.padding,
      _ref$noTags = _ref.noTags,
      noTags = _ref$noTags === void 0 ? posts.filter(function (post) {
    return post.node.frontmatter.tags === null || post.node.frontmatter.tags === undefined;
  }) : _ref$noTags;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Layout["default"], {
      langKey: fields.langKey,
      slug: fields.slug
    },
    /*#__PURE__*/
    _react["default"].createElement("section", {
      className: "hero is-small is-fullheight",
      style: {
        padding: padding,
        display: 'block'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactHelmet["default"], {
      title: "Tags | ".concat(title)
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "hero-body"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "container content"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "columns"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "column is-10 is-offset-1",
      style: {
        marginBottom: '6rem'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("h1", {
      className: "title is-size-6 is-bold-light"
    }, frontmatter.title),
    /*#__PURE__*/
    _react["default"].createElement("ul", null, group.map(function (tag) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null, tags.tagList && tags.tagList // .filter(tagDef => tagDef.featured === false && tagDef.topLevel && tagDef.tag !== "test")
        .filter(function (tagDef) {
          return tagDef.topLevel && tagDef.tag !== "test";
        }).map(function (tagDef) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("div", null, (0, _lodash.toUpper)(tagDef.tag) === (0, _lodash.toUpper)(tag.fieldValue) &&
            /*#__PURE__*/
            _react["default"].createElement("div", null, tagDef.translations && tagDef.translations.filter(function (translation) {
              return translation.langKey === fields.langKey;
            }).map(function (translation) {
              return (
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null, translation.shortDesc !== null && translation.shortDesc !== "" && translation.tagDisplay !== null && translation.tagDisplay !== "" ?
                /*#__PURE__*/
                _react["default"].createElement("li", {
                  key: tagDef.tag
                },
                /*#__PURE__*/
                _react["default"].createElement(_gatsby.Link, {
                  to: "/".concat(tagDef.tag, "/")
                }, translation.tagDisplay, " "), "(", tag.totalCount, "): ", translation.shortDesc) :
                /*#__PURE__*/
                _react["default"].createElement(_react["default"].Fragment, null, tagDef.translations.filter(function (defTranslation) {
                  return defTranslation.langKey === (translation.overrideDefaultLangKey ? translation.overrideDefaultLangKey : tags.defaultLangKey);
                }).map(function (defTranslation) {
                  return (
                    /*#__PURE__*/
                    _react["default"].createElement(_react["default"].Fragment, null, translation.shortDesc !== null && translation.shortDesc !== "" && (translation.tagDisplay === null || translation.tagDisplay === "") &&
                    /*#__PURE__*/
                    _react["default"].createElement("li", {
                      key: tagDef.tag
                    },
                    /*#__PURE__*/
                    _react["default"].createElement(_gatsby.Link, {
                      to: "/".concat(tagDef.tag, "/")
                    }, defTranslation.tagDisplay, " "), "(", tag.totalCount, "): ", translation.shortDesc), (translation.shortDesc === null || translation.shortDesc === "") && translation.tagDisplay !== null && translation.tagDisplay !== "" &&
                    /*#__PURE__*/
                    _react["default"].createElement("li", {
                      key: tagDef.tag
                    },
                    /*#__PURE__*/
                    _react["default"].createElement(_gatsby.Link, {
                      to: "/".concat(tagDef.tag, "/")
                    }, translation.tagDisplay, " "), "(", tag.totalCount, "): ", defTranslation.shortDesc), (translation.shortDesc === null || translation.shortDesc === "") && (translation.tagDisplay === null || translation.tagDisplay === "") &&
                    /*#__PURE__*/
                    _react["default"].createElement("li", {
                      key: tagDef.tag
                    },
                    /*#__PURE__*/
                    _react["default"].createElement(_gatsby.Link, {
                      to: "/".concat(tagDef.tag, "/")
                    }, defTranslation.tagDisplay, " "), "(", tag.totalCount, "): ", defTranslation.shortDesc))
                  );
                })))
              );
            })))
          );
        }))
      );
    })),
    /*#__PURE__*/
    _react["default"].createElement(_BlogRoll["default"], {
      langKey: fields.langKey,
      isTags: true,
      data: noTags
    })))))))
  );
};

var _default = AllTagsPage;
exports["default"] = _default;